import { InputControl } from "./input-control";
export class DateInputControl extends InputControl {
    get showTime() {
        let format = ['YYYY-MM-DD HH:mm', 'YYYY-MM-DD HH:mm:ss', 'HH:mm:ss', 'HH:mm'];
        return format.indexOf(this.controlOpts.format) > -1;
    }
    get timeType() {
        return ['HH:mm:ss', 'HH:mm'].indexOf(this.controlOpts.format) > -1;
    }
    get showMonth() {
        return this.controlOpts.format.toUpperCase() === "YYYY-MM";
    }
    get format() {
        let format = this.controlOpts.format;
        if (!format) {
            return "YYYY-MM-DD";
        }
        if (this.timePicker) {
            return format;
        }
        const idx = format.indexOf(" ");
        if (idx === -1) {
            return format.toUpperCase();
        }
        format = format.substr(0, idx).toUpperCase() + format.substr(idx);
        return format;
    }
    get timePicker() {
        let format = this.controlOpts.format;
        let type = ["HH:mm:ss", "HH:mm"];
        return type.some(v => v === format);
    }
    get dateCtrl() {
        return this.ctrl;
    }
}
